var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Drawer',{on:{"drawer-resize":_vm.toggleResize}}),_c('div',{staticClass:"app-main-layout",style:(_vm.padding)},[_c('main',{staticClass:"app-content"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }